import { useTranslation } from 'react-i18next';
import { StyledButtonBlue, StyledButtonWrapper, StyledButtonBlueUnbordered } from 'components/styledComponents/button/Button.styled';
import { ButtonProps } from 'antd';

interface ButtonsProps extends ButtonProps {
  onDiscard: ButtonProps['onClick'];
  onApply: ButtonProps['onClick'];
  okText?: string;
  cancelText?: string;
  okDisabled?: boolean;
  cancelDisabled?: boolean;
  isCenter?: boolean;
  isSubmit?: boolean;
  hideOk?: boolean;
}

const Buttons = ({
  onDiscard, onApply, okText = 'save', cancelText = 'cancel', okDisabled, size = 'large', isCenter, cancelDisabled, isSubmit, hideOk,
}:ButtonsProps) => {
  const { t } = useTranslation();

  return (
    <StyledButtonWrapper $isCenter={isCenter}>
      <StyledButtonBlueUnbordered onClick={onDiscard} $size={size} disabled={cancelDisabled}>
        {t(cancelText)}
      </StyledButtonBlueUnbordered>
      {!hideOk && (
        <StyledButtonBlue htmlType={isSubmit ? 'submit' : 'button'} onClick={onApply} size={size} disabled={okDisabled}>
          {t(okText)}
        </StyledButtonBlue>
      )}
    </StyledButtonWrapper>
  );
};

export default Buttons;
